module.exports = __webpack_public_path__ + "static/img/celoscope-detail-33.7f14394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-33.jpg
// module id = 5dCP
// module chunks = 51